/* =============================================================================
   Signal sonore de notification
   ─────────────────────────────────────────────────────────────────────────
   Le son est SYNTHETISE, pas charge depuis un fichier : deux notes breves
   suffisent, et cela evite d'embarquer un fichier audio, de le servir, de le
   mettre en cache et de gerer son echec de chargement.

   Deux contraintes de navigateur a connaitre :

   1. Un son ne peut pas etre joue tant que l'utilisateur n'a pas interagi avec
      la page. Ce n'est pas un probleme ici — on ne recoit une notification
      qu'apres s'etre connecte, donc apres avoir clique — mais si le contexte
      audio est cree trop tot il naitra « suspendu ». On le cree donc a la
      demande, et on tente de le reveiller.

   2. Un contexte audio est une ressource : on n'en cree qu'un seul, reutilise.

   L'echec est toujours silencieux : ne pas entendre le son est un desagrement,
   une erreur en console serait un defaut.
   ============================================================================= */

const CLE_SOURDINE = 'peak_notif_sourdine';

let contexte = null;

export const sourdineActive = () => {
  try { return localStorage.getItem(CLE_SOURDINE) === '1'; } catch (e) { return false; }
};

export const basculerSourdine = () => {
  const nouvelle = !sourdineActive();
  try { localStorage.setItem(CLE_SOURDINE, nouvelle ? '1' : '0'); } catch (e) { /* stockage indisponible */ }
  return nouvelle;
};

function obtenirContexte() {
  if (contexte) return contexte;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  contexte = new Ctx();
  return contexte;
}

/** Deux notes ascendantes, breves et douces : une notification de bureau ne
 *  doit pas faire sursauter dans une boutique. */
export function jouerSonNotification() {
  if (sourdineActive()) return;
  try {
    const ctx = obtenirContexte();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume();

    const notes = [
      { frequence: 880, debut: 0, duree: 0.12 },   // la
      { frequence: 1174, debut: 0.11, duree: 0.20 }, // re, une quarte au-dessus
    ];

    notes.forEach(({ frequence, debut, duree }) => {
      const t = ctx.currentTime + debut;
      const oscillateur = ctx.createOscillator();
      const volume = ctx.createGain();
      // Une sinusoide sonne douce ; un signal carre serait strident.
      oscillateur.type = 'sine';
      oscillateur.frequency.setValueAtTime(frequence, t);
      // Attaque et extinction progressives : une coupure nette produit un clic.
      volume.gain.setValueAtTime(0.0001, t);
      volume.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
      volume.gain.exponentialRampToValueAtTime(0.0001, t + duree);
      oscillateur.connect(volume).connect(ctx.destination);
      oscillateur.start(t);
      oscillateur.stop(t + duree + 0.02);
    });
  } catch (e) {
    /* Navigateur sans Web Audio, ou son bloque : on continue sans bruit. */
  }
}
